import React from 'react';
import { Reveal } from './ui/Reveal';
import { Button } from './ui/Button';
import { Calendar, Clock, Users, Award, Sprout, Activity, Sparkles, Moon } from 'lucide-react';
export function CoursesSection() {
  const courses = [{
    title: 'Yoga para Principiantes',
    duration: '4 semanas',
    schedule: 'Sábados 9:00 AM',
    capacity: '12 personas',
    level: 'Principiante',
    description: 'Curso introductorio perfecto para quienes nunca han practicado yoga. Aprenderás las posturas básicas, técnicas de respiración y meditación.',
    price: '$1',
    icon: <Sprout className="text-sage" size={32} data-id="element-949" />,
    color: 'sage'
  }, {
    title: 'Hatha Yoga Intermedio',
    duration: '6 semanas',
    schedule: 'Domingos 10:00 AM',
    capacity: '10 personas',
    level: 'Intermedio',
    description: 'Profundiza tu práctica con secuencias más desafiantes, posturas de equilibrio y técnicas avanzadas de pranayama.',
    price: '$1',
    icon: <Activity className="text-earth" size={32} data-id="element-950" />,
    color: 'earth'
  }, {
    title: 'Vinyasa Flow',
    duration: '4 semanas',
    schedule: 'Sábados 5:00 PM',
    capacity: '15 personas',
    level: 'Todos los niveles',
    description: 'Fluye a través de secuencias dinámicas sincronizadas con la respiración. Aumenta fuerza, flexibilidad y concentración.',
    price: '$1',
    icon: <Sparkles className="text-virtual" size={32} data-id="element-951" />,
    color: 'virtual'
  }, {
    title: 'Yoga Restaurativo',
    duration: '4 semanas',
    schedule: 'Domingos 6:00 PM',
    capacity: '8 personas',
    level: 'Todos los niveles',
    description: 'Práctica suave enfocada en la relajación profunda y la recuperación. Ideal para reducir estrés y mejorar el sueño.',
    price: '$1',
    icon: <Moon className="text-sage" size={32} data-id="element-952" />,
    color: 'sage'
  }];
  return <section className="py-24 px-6 md:px-16" data-id="element-953">
      <div className="max-w-7xl mx-auto" data-id="element-954">
        <Reveal className="text-center mb-16" data-id="element-955">
          <span className="inline-block bg-sage-light/30 text-earth text-xs font-semibold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-4" data-id="element-956">
            Cursos
          </span>
          <h2 className="font-display text-4xl md:text-5xl text-earth mb-4" data-id="element-957">
            Programas Especializados
          </h2>
          <p className="text-stone text-lg max-w-2xl mx-auto" data-id="element-958">
            Cursos estructurados para profundizar tu práctica y alcanzar tus
            objetivos
          </p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12" data-id="element-959">
          {courses.map((course, index) => <Reveal key={index} delay={index * 100} data-id="element-960">
              <div className="bg-white rounded-3xl p-8 border border-earth/5 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1" data-id="element-961">
                <div className="flex items-start justify-between mb-6" data-id="element-962">
                  <div className="w-16 h-16 bg-gradient-to-br from-sage-light to-sand rounded-2xl flex items-center justify-center text-3xl" data-id="element-963">
                    {course.icon}
                  </div>
                  <span className="px-3 py-1 bg-sage-light/20 text-sage text-xs font-semibold rounded-full" data-id="element-964">
                    {course.level}
                  </span>
                </div>

                <h3 className="font-display text-2xl text-earth mb-3" data-id="element-965">
                  {course.title}
                </h3>
                <p className="text-stone text-sm leading-relaxed mb-6" data-id="element-966">
                  {course.description}
                </p>

                <div className="grid grid-cols-2 gap-4 mb-6" data-id="element-967">
                  <div className="flex items-center gap-2 text-sm text-stone" data-id="element-968">
                    <Clock size={16} className="text-sage" data-id="element-969" />
                    {course.duration}
                  </div>
                  <div className="flex items-center gap-2 text-sm text-stone" data-id="element-970">
                    <Calendar size={16} className="text-sage" data-id="element-971" />
                    {course.schedule}
                  </div>
                  <div className="flex items-center gap-2 text-sm text-stone" data-id="element-972">
                    <Users size={16} className="text-sage" data-id="element-973" />
                    {course.capacity}
                  </div>
                  <div className="flex items-center gap-2 text-sm text-stone" data-id="element-974">
                    <Award size={16} className="text-sage" data-id="element-975" />
                    Certificado
                  </div>
                </div>

                <div className="flex items-center justify-between pt-6 border-t border-earth/5" data-id="element-976">
                  <div className="font-display text-3xl text-earth font-bold" data-id="element-977">
                    {course.price}
                  </div>
                  <Button variant="sage" data-id="element-978">Inscribirme</Button>
                </div>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={400} data-id="element-979">
          <div className="bg-sand rounded-3xl p-8 md:p-12" data-id="element-980">
            <div className="max-w-3xl mx-auto text-center" data-id="element-981">
              <h3 className="font-display text-3xl text-earth mb-4" data-id="element-982">
                ¿Necesitas un curso personalizado?
              </h3>
              <p className="text-stone leading-relaxed mb-6" data-id="element-983">
                Ofrecemos programas privados y para grupos corporativos.
                Diseñamos el curso perfecto para tus necesidades específicas,
                horarios y objetivos.
              </p>
              <Button variant="primary" size="lg" data-id="element-984">
                Solicitar Información
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}